export default "__VITE_ASSET__KN44gzQg__"